/**
 * Etiqueta que se muestra cuando una butaca quedó bloqueada por un evento.
 *
 * El backend guarda el nombre del evento dentro de `concepto` con el formato
 * "<motivo> Entrada evento: <nombre>" (App\Models\Asiento::sincronizar). Ese
 * texto es además un MARCADOR FUNCIONAL: la liberación automática de butacas lo
 * busca con `LIKE '%Entrada evento:%'`. Por eso NO se reescribe el dato en el
 * backend: la UI lo traduce al mostrarlo.
 */
const CONCEPTO_BLOQUEO_EVENTO = 'Bloqueo entrada evento'

/**
 * Marca que el backend escribe en `estado` cuando el bloqueo proviene de un
 * evento (el bloqueo manual del admin usa 'BLOQUEADO').
 */
const ESTADO_BLOQUEO_EVENTO = 'BLOQUEADO EVENTO'

/**
 * Fallback por si el payload no expone `estado`: el texto del backend es
 * inequívoco y siempre lo incluye el bloqueo de evento.
 */
const PATRON_ENTRADA_EVENTO = /Entrada evento:/i

/**
 * Indica si un bloqueo proviene de un evento (y no de un bloqueo manual).
 *
 * @param {Object} bloqueo
 * @param {string} [bloqueo.estado] - Estado persistido ('BLOQUEADO EVENTO' | 'BLOQUEADO').
 * @param {string} [bloqueo.concepto] - Concepto con el nombre del evento embebido.
 * @returns {boolean}
 */
export function esBloqueoEvento({ estado, concepto } = {}) {
    if (estado === ESTADO_BLOQUEO_EVENTO) {
        return true
    }

    return typeof concepto === 'string' && PATRON_ENTRADA_EVENTO.test(concepto)
}

/**
 * Devuelve el texto a mostrar para un bloqueo: "Bloqueo entrada evento" cuando
 * lo originó un evento, o el concepto tal cual cuando es un bloqueo manual.
 *
 * @param {Object} bloqueo
 * @param {string} [bloqueo.estado]
 * @param {string} [bloqueo.concepto]
 * @returns {string}
 */
export function resolveConceptoBloqueo({ estado, concepto } = {}) {
    if (esBloqueoEvento({ estado, concepto })) {
        return CONCEPTO_BLOQUEO_EVENTO
    }

    return concepto ?? ''
}

export { CONCEPTO_BLOQUEO_EVENTO, ESTADO_BLOQUEO_EVENTO }
